// JavaScript Document
var $ = jQuery.noConflict();
/* equalhight */
$(function () {
  $(".quick-heading").click(function () {
    $(".quick-links").slideToggle("300").toggleClass("active-quick-links");
    $(this).toggleClass("active");
  });
});

$(function () {
  $("body").on("click", ".team-slick-carousel .team-img", function (e) {
    e.preventDefault();
    $(".team-slick-carousel .team-list-item").removeClass("is-active");
    $(".team-slick-carousel li").removeClass("people-sec-active");
    $(".team-slick-carousel .team-list-item").addClass("is-active");
    let imgId = $(this).data("id");

    if (
      $(".team-carousel-content[data-id=" + imgId + "]").hasClass("is-active")
    ) {
      $(".team-carousel-content[data-id=" + imgId + "]").removeClass(
        "is-active",
      );
    } else {
      $(".team-carousel-content").removeClass("is-active");
      $(".team-carousel-content[data-id=" + imgId + "]").addClass("is-active");
    }
  });

  $("body").on("click", ".meet-people-list .slick-dots button", function (e) {
    e.preventDefault();
    $(".team-slick-carousel .team-list-item").removeClass("is-active");
    $(".team-slick-carousel li").removeClass("people-sec-active");
    $(".team-carousel-content").removeClass("is-active");
  });

  $("body").on("click", ".meet-people-list .slick-arrow", function (e) {
    e.preventDefault();
    $(".team-slick-carousel .team-list-item").removeClass("is-active");
    $(".team-slick-carousel li").removeClass("people-sec-active");
    $(".team-carousel-content").removeClass("is-active");
  });
});

$(function () {
  $(".js-slick-carousel").slick({
    dots: true,
    arrows: true,
    draggable: true,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    speed: 600,
    infinite: false,
    cssEase: "ease-out",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

(function ($) {
  $("body").on(
    "click",
    ".top-menu li.menu-item-has-children > span",
    function () {
      $(this).toggleClass("up");
      console.log("click");
    },
  );
})(jQuery);

(function ($) {
  $(".js-faqs-toggle ul li a").each(function () {
    $(this).on("click", function () {
      var theId = $(this).attr("href").split("#")[1];
      setTimeout(function () {
        $(".accordion-item#" + theId).prop("open", true);
      }, 600);
    });
  });

  var hashUrl = window.location.hash;
  if (hashUrl) {
    setTimeout(function () {
      $(".accordion-item" + hashUrl).prop("open", true);
    }, 600);
  }
})(jQuery);

// Exclusive open: opening an accordion item closes its siblings in the same section.
// The native `toggle` event on <details> does not bubble (and in some browsers does
// not fire even on the element), so it cannot drive a delegated document listener.
// Clicks on <summary> always bubble, so close siblings when the clicked item is about
// to open. A direct toggle listener is kept as a fallback for programmatic opens.
$(document).on("click", ".accordion-item > .accordion-title", function () {
  var $item = $(this).closest(".accordion-item");
  if (!$item.prop("open")) {
    $item.siblings(".accordion-item").prop("open", false);
  }
});
$(document).on("toggle", ".accordion-item", function () {
  if (this.open) {
    $(this).siblings(".accordion-item").prop("open", false);
  }
});

function equalhight() {
  $(".team-item").each(function (index, el) {
    if ($(el).find(".team-img").length > 0) {
      var $height = 0;
      $(el)
        .find(".team-img")
        .each(function (index2, el2) {
          $(el2).css("height", "auto");
          if ($(el2).innerHeight() > $height) {
            $height = $(el2).outerHeight();
          }
        });
      $(el).find(".team-img").css("height", $height);
    }
  });
}

$(window).on("load", function (e) {
  equalhight();
  var href_val = window.location.hash;
  $(".meet-people-list .team-img").each(function () {
    e.preventDefault();
    var data_name_val = "#" + $(this).find(".team-name").attr("data-name");
    if (href_val == data_name_val) {
      if (!$(this).closest("li").hasClass("people-sec-active")) {
        $(".meet-people-list > li").removeClass("people-sec-active");
        $(".team-content").hide();
        $(".team-content-wrap").css("height", "auto");
        $(this).closest("li").addClass("people-sec-active");
        var teamh = $(".people-sec-active .team-content").outerHeight();
        $(".people-sec-active .team-content").parent().height(teamh);
        $(this)
          .closest("li.people-sec-active")
          .find(".team-content")
          .stop()
          .slideDown(500, function () {
            $(".people-sec-active .team-content").parent().height(teamh);
            if ($(window).scrollTop() != $(".people-sec-active").offset().top) {
              if ($("#menu-toggle").is(":hidden")) {
                $("html, body")
                  .stop()
                  .animate(
                    {
                      scrollTop: $(".people-sec-active").offset().top,
                    },
                    300,
                  );
              } else {
                $("html, body")
                  .stop()
                  .animate(
                    {
                      scrollTop: $(".people-sec-active").offset().top,
                    },
                    300,
                  );
              }
            }
          });
      }
    }
  });
});
$(document).ready(function () {
  // Contact form handlers
  // Event handler for form open button click
  $(".form-open-btn").click(function (e) {
    $(".get-touch-form").slideDown("slow");
    e.preventDefault();
    $(this).addClass("active");
  });

  // Event handler for online enquiry button click
  $(".onlineenquiry").on("click", function (e) {
    e.preventDefault();
    $(".form-open-btn").trigger("click");
    $("html, body").animate({
      scrollTop: $(".get-touch-sec").offset().top,
    });
  });

  // Handle initial URL hash
  handleHashChange(window.location.hash);

  // Listen for changes in the URL hash
  window.addEventListener("popstate", function () {
    handleHashChange(window.location.hash);
  });

  // Function to handle changes in the URL hash
  function handleHashChange(hash) {
    if (hash === "#enquiry") {
      $(".form-open-btn").trigger("click");
      $("html, body").animate({
        scrollTop: $(".get-touch-sec").offset().top,
      });
    }
  }

  $(".back-top").click(function (e) {
    e.preventDefault();
    $("html, body").stop().animate(
      {
        scrollTop: 0,
      },
      1000,
    );
  });

  $(".enumenu_ul").responsiveMenu({
    menuIcon_text: "",
    onMenuopen: function () {},
  });

  // Ovulation Calculator
  $(".selectbox1").selectbox({
    hide_duplicate_option: true,
  });
  $(".selectbox2").selectbox({
    hide_duplicate_option: true,
  });
  $(".selectbox3").selectbox({
    hide_duplicate_option: true,
  });
  $(".selectbox4").selectbox({
    hide_duplicate_option: true,
  });
  $(".selectbox5").selectbox({
    hide_duplicate_option: true,
  });
  $(".is-cycle-regular").selectbox({
    hide_duplicate_option: true,
    onChange: (val) => {
      $(".display-when-no").removeClass("is-active");
      $(".display-when-yes").removeClass("is-active");
      if (val === "no") {
        $(".display-when-no").addClass("is-active");
      }
      if (val === "yes") {
        $(".display-when-yes").addClass("is-active");
      }
    },
  });

  // Pregnancy Calculator
  $(".conceptiontype").selectbox({
    hide_duplicate_option: true,
    onChange: (val) => {
      $(".display-when-natural").removeClass("is-active");
      $(".display-when-ivf").removeClass("is-active");
      $(".display-when-iui").removeClass("is-active");
      if (val === "natural") {
        $(".display-when-natural").addClass("is-active");
      }
      if (val === "ivf") {
        $(".display-when-ivf").addClass("is-active");
      }
      if (val === "iui") {
        $(".display-when-iui").addClass("is-active");
      }
    },
  });

  $(".transfertype").selectbox({
    hide_duplicate_option: true,
  });

  $(".sidebar-select").selectbox({
    hide_duplicate_option: true,
  });

  // team js
  $(".meet-people-list .team-img").click(function (e) {
    e.preventDefault();
    if (!$(this).closest("li").hasClass("people-sec-active")) {
      $(".meet-people-list > li").removeClass("people-sec-active");
      $(".team-content").hide();
      $(".team-content-wrap").css("height", "auto");
      $(this).closest("li").addClass("people-sec-active");
      var teamh = $(".people-sec-active .team-content").outerHeight();
      $(".people-sec-active .team-content").parent().height(teamh);
      $(this)
        .closest("li.people-sec-active")
        .find(".team-content")
        .stop()
        .slideDown(500, function () {
          $(".people-sec-active .team-content").parent().height(teamh);
          if ($(window).scrollTop() != $(".people-sec-active").offset().top) {
            if ($("#menu-toggle").is(":hidden")) {
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: $(".people-sec-active").offset().top,
                  },
                  300,
                );
            } else {
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: $(".people-sec-active").offset().top,
                  },
                  300,
                );
            }
          }
        });
    } else {
      event.preventDefault();
      $(this).closest("li").removeClass("people-sec-active");
      $(this)
        .closest("li")
        .removeClass("people-sec-active")
        .find(".team-content")
        .stop()
        .slideUp(600);
      var this_ = $(this);
      this_
        .closest("li")
        .find(".team-content-wrap")
        .stop()
        .animate(
          {
            height: 0,
          },
          600,
          function () {
            $(this).css("height", "");
          },
        );
    }
  });

  $(".enumenu_ul.top-menu > li").click(function () {
    if ($(".menu-icon").css("display") == "block") {
      if ($(this).hasClass("has-children")) {
        $(this).children(".sub-menu").slideToggle();
      } else {
        window.location = this.href;
      }
    }
  });

  $(".menu-icon").on("click", function () {
    if ($(window).innerWidth() <= 991) {
      if (!$(this).hasClass("mob-menu-active")) {
        $(".menu-icon").removeClass("mob-menu-active");
        $(this).addClass("mob-menu-active");
        $(this).nextAll(".enumenu_ul.menu").slideDown();
      } else {
        $(this)
          .removeClass("mob-menu-active")
          .nextAll(".enumenu_ul.menu, .mob-menu")
          .slideUp();
      }
    }
  });
  if ($(".menu-icon").css("display") == "block") {
    $(".header-top-menu .enumenu_ul").insertAfter(
      ".menu-sec .enumenu_ul.menu.mob",
    );
    $(".enumenu_ul.menu.desk").addClass("mob-menu");
  }

  $(window).resize(function (event) {
    equalhight();
    var teamh = $(".people-sec-active .team-content").outerHeight();
    $(".people-sec-active .team-content").parent().height(teamh);
    if ($(".menu-icon").css("display") == "block") {
      $(".header-top-menu .enumenu_ul").insertAfter(
        ".menu-sec .enumenu_ul.menu.mob",
      );
      $(".enumenu_ul.menu.desk").addClass("mob-menu");
    } else {
      if ($(".enumenu_ul.top-menu").css("display") == "block") {
        $(".enumenu_ul.top-menu > li .sub-menu").hide();
        $(".enumenu_ul.top-menu").hide();
        $(".menu-icon").removeClass("mob-menu-active");
        $(".sub-menu.sb-menu").removeAttr("style");
      }

      if ($(".mob-menu").length > 0) {
        $(".mob-menu").insertAfter(".header-top-menu .menu-icon");
      }
    }
  });

  /*
   * Ovulation Calculator
   */
  $("#ovulcal").on("click", function () {
    $.ajax({
      url: ajax_variable,
      type: "POST",
      dataType: "json",
      data: {
        action: "calculate_ovulation",
        datemonth: $(".datemonth").val(),
        dateday: $(".dateday").val(),
        dateyear: $(".dateyear").val(),
        days: $(".days").val(),
        shortcycledays: $(".shortcycledays").val(),
        longcycledays: $(".longcycledays").val(),
        regular: $(".is-cycle-regular").val() === "yes" ? true : false,
        postid: post_id,
      },
      beforeSend: function () {
        $(".loader").show();
      },
      complete: function () {
        $(".loader").hide();
      },
      success: function (r) {
        if (r.response == "success") {
          $(".calc_ques").hide();
          $(".fertility-result").show();
          $(".fertility-result").html(r.message);
        } else {
          $(".calc_ques").hide();
          $(".fertility-result").show();
          $(".fertility-result").html(
            '<div class="error-section">' + r.message + "</div>",
          );
        }
      },
    });
  });

  /*
   * Pregnancy Calculator
   */
  $("#pregcal").on("click", function () {
    var conceptionType = $(".conceptiontype").val();
    var datemonth, dateday, dateyear;

    if (conceptionType === "natural") {
      datemonth = $(".display-when-natural .datemonth").val();
      dateday = $(".display-when-natural .dateday").val();
      dateyear = $(".display-when-natural .dateyear").val();
    } else if (conceptionType === "iui") {
      datemonth = $(".display-when-iui .datemonth").val();
      dateday = $(".display-when-iui .dateday").val();
      dateyear = $(".display-when-iui .dateyear").val();
    } else {
      datemonth = $(".datemonth").val();
      dateday = $(".dateday").val();
      dateyear = $(".dateyear").val();
    }
    // Ensure dateyear is an integer
    dateyear = parseInt(dateyear);

    $.ajax({
      url: ajax_variable,
      type: "POST",
      dataType: "json",
      data: {
        action: "calculate_pregnancy",
        datemonth: datemonth,
        dateday: dateday,
        dateyear: dateyear,
        conceptiontype: conceptionType,
        transfertype: $(".transfertype").val(),
        postid: post_id,
      },
      cache: false, // Prevent caching
      beforeSend: function () {
        $(".loader").show();
      },
      complete: function () {
        $(".loader").hide();
      },
      success: function (r) {
        if (r.response == "success") {
          $(".calc_ques").hide();
          $(".fertility-result").show().html(r.message);
        } else {
          $(".calc_ques").hide();
          $(".fertility-result")
            .show()
            .html('<div class="error-section">' + r.message + "</div>");
        }
      },
    });
  });

  /*
   * Calculate again click events
   */
  $("body").on("click", ".calculate_again_pregnancy", function () {
    // Refresh the page to reset the form
    location.reload();
  });

  $("body").on("click", ".calculate_again_ovulation", function () {
    // Refresh the page to reset the form
    location.reload();

    // Scroll to the 'Calc questions' section
    $("html, body").animate(
      {
        scrollTop: $(".calc_ques").offset().top + 35,
      },
      500,
    ); // 500ms for smooth scrolling
  });

  // Common function to get URL parameter
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  // Filter posts
  function makeAjaxRequest(
    action,
    cat_id,
    author_id,
    posts_per_page,
    offset,
    page_id,
    search_text,
    search_type,
  ) {
    $.ajax({
      url: ajax_variable,
      type: "POST",
      dataType: "json",
      data: {
        action: action,
        cat_id: cat_id,
        author_id: author_id,
        posts_per_page: posts_per_page,
        offset: offset,
        page_id: page_id,
        search_text: search_text,
        search_type: search_type,
      },
      beforeSend: function () {
        $(".loader").show();
      },
      complete: function () {
        $(".loader").hide();
      },
      success: function (r) {
        if (r.response == "success") {
          $(".blog-post-listing").html(r.message);
          if (r.pagination_struc != "") {
            $(".blog-pagination").show();
            $(".pagination_wrapper").html(r.pagination_struc);
          } else {
            $(".blog-pagination").hide();
          }
        } else {
          $(".blog-post-listing").html(
            '<div class="error-section">' + r.message + "</div>",
          );
          $(".blog-pagination").hide();
        }
      },
    });
  }

  // Determine action based on URL
  var isResearchPage = window.location.href.includes("/research/");
  var loadMoreAction = isResearchPage
    ? "get_load_more_post_research"
    : "get_load_more_post";
  var paginationAction = isResearchPage
    ? "get_load_more_post_pagination_research"
    : "get_load_more_post_pagination";
  var textboxSearchAction = isResearchPage
    ? "get_post_custom_textbox_search_research"
    : "get_post_custom_textbox_search";

  if (window.location.href.includes("/blog/") || isResearchPage) {
    if (getUrlParameter("topic")) {
      var topic = getUrlParameter("topic");
      setTimeout(() => {
        $(".category_filter + .sbHolder ul li a[rel=" + topic + "]").trigger(
          "click",
        );
      });
    }

    // Bind click event using event delegation for dynamic elements
    $(document).on(
      "click",
      ".category_filter + .sbHolder ul li a, .author_filter + .sbHolder ul li a",
      function () {
        var author_id = $(".author_filter").val();
        $("#author_id").val(author_id);
        var cat_id = $(".category_filter").val();
        $("#cat_id").val(cat_id);
        var posts_per_page = $("#posts_per_page").val();
        var offset = $("#offset").val(0).val();
        $("#search_type").val("default");
        $("#search-text").val("");
        makeAjaxRequest(
          loadMoreAction,
          cat_id,
          author_id,
          posts_per_page,
          offset,
        );
      },
    );

    // Pagination AJAX data
    $(document).on("click", ".pagination_pageno", function () {
      if ($.trim(this.className) != "pagination_pageno") {
        return false;
      }

      $(".pagination_pageno").removeClass("active");
      $(".pagination_pageno[data-id=" + $(this).attr("data-id") + "]").addClass(
        "active",
      );

      var author_id = $("#author_id").val();
      var cat_id = $("#cat_id").val();
      var posts_per_page = $("#posts_per_page").val();
      var page_id = $(this).attr("data-id");
      var search_type = $("#search_type").val();
      var search_text = $("#search-text").val();
      $("#offset").val(0);
      var offset = $("#offset").val();

      if (offset == null || offset == 0) offset = 0;
      makeAjaxRequest(
        paginationAction,
        cat_id,
        author_id,
        posts_per_page,
        offset,
        page_id,
        search_text,
        search_type,
      );
    });

    // Text box search
    $("#search-text").keyup(function () {
      $(".fertile-select-row .sbHolder").each(function () {
        $(this).find(".sbOptions li").removeAttr("style");
        var res_text = $(this).find(".sbOptions li:first-child a").text();
        $(this).find(".sbSelector a").text(res_text);
      });
      $(".author_filter").val("");
      $("#author_id").val("");
      $(".category_filter").val("");
      $("#cat_id").val("");
      var text = $(".selectbox-row .sbOptions li a").text();
      $(".selectbox-row .sbSelector a").val(text);

      var search_text = $(this).val();
      var posts_per_page = $("#posts_per_page").val();
      $("#search_type").val("text");
      $("#offset").val(0);
      var offset = $("#offset").val();

      if (offset == null || offset == 0) offset = 0;
      makeAjaxRequest(
        textboxSearchAction,
        "",
        "",
        posts_per_page,
        offset,
        "",
        search_text,
        "text",
      );
    });
  }
});

// Open form from targeted anchor link
$(document).ready(function () {
  // GET THE ANCHOR
  let the_html_anchor = window.location.hash;

  // IF WE HAVE AN ANCHOR
  if (the_html_anchor) {
    // REMOVE #
    let the_html_anchor_hashless = the_html_anchor.replace("#", "");

    // OPEN FAQ
    $("ul.accordion li h4#" + the_html_anchor_hashless + "")
      .parent()
      .attr("state", "open");
    $("ul.accordion li h4#" + the_html_anchor_hashless + "")
      .parent()
      .addClass("open");
    $("ul.accordion li h4#" + the_html_anchor_hashless + "")
      .siblings(".the_content")
      .slideDown();
  }

  $(".accordion .title").each(function () {
    $(this).click(function () {
      let the_state = $(this).parent().attr("state");

      if (the_state == "closed") {
        the_state = $(this).parent().attr("state", "open");
        $(this).parent().addClass("open");
        $(this).siblings(".the_content").slideDown();
      } else {
        the_state = $(this).parent().attr("state", "closed");
        $(this).parent().removeClass("open");
        $(this).siblings(".the_content").slideUp();
      }
    });
  });
});
